import React, { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import Modal from "/src/components/modal/Modal";
import ButtonAction from "/src/components/UI/Button/Button";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import statementService from '/src/features/dataset/services/statementService';
import "./ImportModal.css";
import "/src/assets/css/polices.css";
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import FormData from 'form-data';
import SpanToast from '/src/layouts/toast/components/SpanToast';
import Field from "/src/components/UI/Field/Field";
import InputBox from "/src/components/UI/InputBox/InputBox";
import { useForm } from "react-hook-form";
const ImportWorksheetModal = NiceModal.create(({ nameDataset, title, data }) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const [file, setFile] = useState();
    const [loadAnim, setLoading] = useState(null);
    const { importStatement } = statementService;

    const [column, setColumn] = useState(false)

    const toast = useToastDispatchContext()

    const onSubmit = async () => {

        const formData = new FormData();
        formData.append("with_columns", column);
        formData.append('file', file);
        let [response, error] = await importStatement(nameDataset, formData) //await importStatement(nameDataset, formData)
        if (error !== null) {
            onClose()
            toast.error('Error', <SpanToast text={error.data} />, 7000)
            return;
        }
        setLoading("finish");
        setTimeout(() => {
            modal.resolve(response);
            onClose()
        }, 2000)
        //modal.resolve(response).then(() => { console.log("test") })

        //return;

    }

    return (
        <Modal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="form-import">
                <Form.Title>Import your Data</Form.Title>
                <Form.Body className="form-import_body">
                    <div className="container_import">
                        <ChooseFile _setFile={setFile} accept=".xlsx,.csv" loadAnim={loadAnim}></ChooseFile>
                        <Field label="With columns" listLabelClassName="titles-input">

                            <InputBox id="statement" style={{ marginLeft: "15px" }} onClick={(val) => setColumn(val)}></InputBox>

                        </Field>
                    </div>
                </Form.Body>
                <Form.Buttons>
                    <div className="button_center">
                        <ButtonAction className="validate" label="Upload" disabled={file != null ? false : true} onClick={() => { onSubmit(); setLoading(true) }} />
                    </div>
                </Form.Buttons>
            </Form>
        </Modal >
    )
});

export default ImportWorksheetModal;